<template>
<div>
<div class="mt-5" v-if="carts.length == 0">
    <br>
    <h2>Add some product to cart</h2>
    <br>
    <img src="https://cdn.dribbble.com/users/812639/screenshots/6486869/shooping_1-800x600.gif" style="width: 50%;">
</div>
<table v-if="carts.length > 0" class="table mt-5">
  <thead class="thead-light">
    <tr>
      <th scope="col">No</th>
      <th scope="col">Image</th>
      <th scope="col">Name</th>
      <th scope="col">Price</th>
      <th scope="col">Amount</th>
      <th scope="col">Action</th>
    </tr>
  </thead>
  <tbody v-if="carts">
    <tr v-for="(product, index) in carts" :key="index">
      <th scope="row">{{index + 1}}</th>
      <td><img :src="product.image_url" style="width: 15vw; height: 10vw"></td>
      <td>{{product.name}}</td>
      <td>Rp {{totalPrice(product.price, product.Cart.amount)}}</td>
      <td>
        <form @submit.prevent="doUpdate(product.id,product.Cart.amount)">
            <input type="number" v-model='product.Cart.amount' min="1" :max="product.stock">
            <hr>
            <button type="submit" class="btn btn-primary">Update</button>
        </form>
      </td>
      <td>
        <button @click="doDelete(product.id)" type="button" class="btn btn-danger">
        <i class="fas fa-trash"></i></button>
      </td>
    </tr>
    <tr v-if="carts.length>0">
        <td></td>
        <td></td>
        <td></td>
        <td><h3>Subtotal: </h3></td>
        <td><p class="price">Rp {{countSubTotal()}}</p></td>
        <td>
        <button @click="doTransaction" type="button" class="btn btn-success">
        <i class="fas fa-file-invoice-dollar"></i> Checkout</button>
        </td>
    </tr>
  </tbody>
</table>
</div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import swal2 from 'sweetalert2'

export default {
    name: 'Cart',
    data() {
        return {
            // url: 'http://localhost:3000'
            url: 'https://dry-savannah-57278.herokuapp.com'
        }
    },
    methods: {
        fetchCarts () {
            this.$store.dispatch('fetchCarts')
        },
        totalPrice(price, amount) {
            return (price * amount);
        },
        doUpdate(id,amount){
            swal({
                title: 'Do you want to update this product amount?',
                buttons: true,
                dangerMode: true,
                closeOnClickOutside: false,
            })
            .then(confirm=>{
                if(confirm){
                    return axios({
                        method: 'put',
                        url: `${this.url}/carts/${id}`,
                        headers: {
                            token: localStorage.token
                        },
                        data: {
                            amount: amount
                        }
                    })
                }
            })
            .then(data=>{
                if (!data) {
                    swal('Done!','Cancel update amount','info')
                } else {
                    swal('Done!','Your cart has been update','success')
                        this.$store.dispatch("fetchCarts");
                    }
                })
            .catch(err=>{
                console.log(err)
            })
        },
        doDelete(id){
            swal({
                title: 'Do you want to delete this product?',
                buttons: true,
                dangerMode: true,
                closeOnClickOutside: false,
            })
            .then(confirm=>{
                if(confirm){
                    return axios({
                        method: 'delete',
                        url: `${this.url}/carts/${id}`,
                        headers: {
                            token: localStorage.token
                        }
                    })
                }
            })
            .then(data=>{
                if (!data) {
                    swal('Done!','Cancel delete product','info')
                } else {
                    swal('Done!','This product has been deleted','success')
                        this.$store.dispatch("fetchCarts");
                    }
                })
            .catch(err=>{
                console.log(err)
            })
        },
        countSubTotal () {
            const cartsList = this.carts
            let subTotal = 0

            cartsList.forEach(el=>{
                subTotal += el.Cart.total
            })

            return subTotal
        },
        doTransaction () {
            let tableCheckout = `Name: ${localStorage.name}
            <br>
            <br>
                <table style="width: 100%;">
                <tr>
                    <th>Product</th>
                    <th>Amount</th>
                    <th>Price</th>
                </tr>`;
            this.$store.state.carts.forEach((cart) => {
                tableCheckout += `<tr>
                <td>${cart.name}</td>
                <td>${cart.Cart.amount}</td>
                <td>${this.totalPrice(cart.price, cart.Cart.amount)}</td></tr>`;
            });
            tableCheckout += `
            </table>
            <hr>
            Subtotal = Rp ${this.countSubTotal()}`;
            swal2.fire({
                title: 'Are you sure?',
                html: tableCheckout,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Checkout Now!',
            })
            .then(result=>{
                if (result.value) {
                    axios({
                        method: 'post',
                        url: `${this.url}/transactions/`,
                        headers: {
                            token: localStorage.token
                        }
                    })
                    .then(()=>{
                        swal('Thank You','Success add cart to transaction','success')
                        this.$router.replace({name:'Transaction'})
                    })
                    .catch(err=>{
                        console.log(err)
                    })
                }
            })
        }
    },
    computed: {
        carts () {
            return this.$store.state.carts
        }
    },
    created() {
        this.fetchCarts()
    }
}
</script>

<style>
    @import url("https://fonts.googleapis.com/css?family=Fjalla+One|Montserrat:300,400,700,800|Open+Sans:300");
    
    p.price {
        font-family: "Fjalla One", sans-serif;
        color: #a1cc16;
        font-size: 26px; 
    }
</style>